/**
 * @typedef CalculatedObj
 * @property { number } unit
 * @property { number } max
 * @property { number } min
 */

/**
 * @typedef MultiUnitCalculatedObj
 * @property { number[] } units
 * @property { number } max
 * @property { number } min
 */

/**
 * カラーチップの色に対応する数字を返す
 * @param { MultiUnitCalculatedObj } targetCondition
 * @param { number } value
 * @return { string }
 */
export function evalPanelColorClassNumber(targetCondition, value) {
  // 全て同じ値だったら、真ん中の色を返す
  if (targetCondition.max === targetCondition.min) return '3'

  if (targetCondition.min <= value && value < targetCondition.units[0]) {
    return '1'
  } else if(targetCondition.units[0] <= value && value < targetCondition.units[1]) {
    return '2'
  } else if(targetCondition.units[1] <= value && value < targetCondition.units[2]) {
    return '3'
  } else if(targetCondition.units[2] <= value && value < targetCondition.units[3]) {
    return '4'
  } else if(targetCondition.units[3] <= value) {
    return '5'
  }
}

/**
 * カラーチップの色を相対評価で算出するための各基準値（値が取り得る範囲を5等分した時の境界の値）を算出して返す
 * 少数や、実際に対象の配列にない数値をそれぞれ取り得るので分位数と呼ばないが概念としてはそれに近い
 * @param { CalculatedObj } value
 * @return { number[] }
 */
export function calcUnits(value) {
  return [
    value.min + value.unit,
    value.min + value.unit * 2,
    value.min + value.unit * 3,
    value.min + value.unit * 4,
  ]
}

/**
 * カラーチップの色を相対評価で算出するための１単位を算出する
 * @param { number } max
 * @param { number } min
 * @param { number } divideBy
 * @return {number}
 */
export function calcUnit(max, min, divideBy = 4) {
  const diff = max - min
  return diff / divideBy
}